import React from "react";
import InfiniteScroll from 'react-infinite-scroll-component';

import {
  Card,
  Row,
  Spinner
} from "react-bootstrap";

function CardsView(props) {

  return (
        <InfiniteScroll
          scrollableTarget="scrollableDiv"
          dataLength={props.artworks ? props.artworks.length : 0}
          next={props.fetchMoreData}
          hasMore={(props.artworks ? props.artworks.length : 0) < props.maxData}
          loader={<Row className="justify-content-center mb-5">
          <Spinner animation="border" variant="primary" />
        </Row>}
        >
          <div className="artwork-grid">
        {props.artworks && props.artworks.map((artwork, idx) => {
          const {
            file_name,
            caption,
            image_url,
            notes,
            keywords,
            thumbnail
          } = artwork;
          const previewSrc = image_url ? image_url : (thumbnail ? thumbnail : "no_preview.png");
          return (
            <Card key={`artwork-${image_url}-${idx}`} className="artwork-card">
              <a
                href={previewSrc}
                target="_blank"
                rel="noreferrer"
                aria-current="true"
                className="thumb-link"
              >
                <div className="thumb-frame">
                  <Card.Img
                    variant="top"
                    src={previewSrc}
                    className="thumb-image"
                  />
                </div>
              </a>
              <Card.Body className="artwork-card-body">
                <div className="thumb-file-name text-muted">{file_name}</div>
                <div className="thumb-caption">{caption}</div>
                <div className="thumb-notes">{notes}</div>
                <div className="thumb-keywords">{keywords}</div>
              </Card.Body>
            </Card>
          );
        })}
         </div>
        </InfiniteScroll>
       );
}

export default CardsView;
